<p-dialog
  [(visible)]="visible"
  [modal]="true"
  header="Décaler l'intervention"
  [style]="{ width: '650px' }"
  (onHide)="hide()"
>
  <div class="p-fluid">
    <div class="mb-3">
      <h3 *ngIf="selectedEvent" class="text-lg font-semibold mb-3">
        {{ selectedEvent.title }}
      </h3>
    </div>

    <form [formGroup]="shiftForm" class="flex flex-col gap-4">
      <!-- Sélection des techniciens -->
      <div class="flex flex-col mb-2">
        <label for="techniciansIds" class="font-bold mb-2">Techniciens*</label>
        <p-multiselect
          id="techniciansIds"
          formControlName="techniciansIds"
          [options]="
            allTechnicians.length ? allTechnicians : availableTechnicians
          "
          optionLabel="fullName"
          optionValue="id"
          placeholder="Sélectionner les techniciens"
          styleClass="w-full"
          appendTo="body"
          [scrollHeight]="'200px'"
        >
          <ng-template pTemplate="selectedItem" let-technician>
            <div class="flex align-items-center gap-2" *ngIf="technician">
              <div>
                {{ technician.firstname + ' ' + technician.lastname }}
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="item" let-technician>
            <div class="flex align-items-center gap-2">
              <div>{{ technician.firstname }} {{ technician.lastname }}</div>
            </div>
          </ng-template>
        </p-multiselect>
        <small
          *ngIf="
            shiftForm.get('techniciansIds')?.invalid &&
            shiftForm.get('techniciansIds')?.touched
          "
          class="p-error mt-1"
        >
          Veuillez sélectionner au moins un technicien.
        </small>
      </div>

      <!-- Date et heure de début -->
      <div class="flex flex-col mb-2">
        <label for="startDate" class="font-bold mb-2"
          >Date et heure de début*</label
        >
        <p-datepicker
          id="startDate"
          formControlName="startDate"
          [showTime]="true"
          [showIcon]="true"
          styleClass="w-full"
          hourFormat="24"
          appendTo="body"
          [touchUI]="false"
        ></p-datepicker>
        <small
          *ngIf="
            shiftForm.get('startDate')?.invalid &&
            shiftForm.get('startDate')?.touched
          "
          class="p-error mt-1"
        >
          Veuillez sélectionner une date et heure de début.
        </small>
      </div>

      <!-- Durée -->
      <div class="flex flex-col mb-2">
        <label for="duration" class="font-bold mb-2">Durée*</label>
        <p-datepicker
          id="duration"
          formControlName="duration"
          [timeOnly]="true"
          styleClass="w-full"
          hourFormat="24"
          [showIcon]="true"
          appendTo="body"
          [touchUI]="false"
        ></p-datepicker>
        <small
          *ngIf="
            shiftForm.get('duration')?.invalid &&
            shiftForm.get('duration')?.touched
          "
          class="p-error mt-1"
        >
          Veuillez sélectionner une durée.
        </small>
      </div>

      <!-- Option créneau horaire -->
      <div class="flex flex-row items-center gap-2 mb-2">
        <p-inputSwitch
          formControlName="isTimeSlot"
          (onChange)="toggleTimeSlot()"
        ></p-inputSwitch>
        <label class="font-bold">Utiliser un créneau horaire</label>
      </div>

      <!-- Éléments de créneau horaire (conditionnels) -->
      <div
        *ngIf="shiftForm.get('isTimeSlot')?.value"
        class="flex flex-col gap-3"
      >
        <!-- Sélection rapide du créneau horaire -->
        <div class="flex flex-col mb-2">
          <label class="font-bold mb-2">Créneau</label>
          <div class="flex gap-2">
            <p-button
              label="Matin (8h-12h)"
              styleClass="p-button-outlined p-button-sm"
              [class.p-button-primary]="selectedTimeSlot === 'morning'"
              (click)="selectTimeSlot('morning')"
            ></p-button>
            <p-button
              label="Après-midi (13h-18h)"
              styleClass="p-button-outlined p-button-sm"
              [class.p-button-primary]="selectedTimeSlot === 'afternoon'"
              (click)="selectTimeSlot('afternoon')"
            ></p-button>
            <p-button
              label="Personnalisé"
              styleClass="p-button-outlined p-button-sm"
              [class.p-button-primary]="selectedTimeSlot === 'custom'"
              (click)="selectTimeSlot('custom')"
            ></p-button>
          </div>
        </div>

        <!-- Message d'avertissement si le créneau ne correspond plus à la date -->
        <div *ngIf="timeSlotMismatch" class="time-slot-mismatch-warning mb-2">
          <div class="subtle-message">
            <i class="pi pi-info-circle mr-2"></i>
            <div class="message-text">
              Le créneau horaire choisi ne correspond plus à la date
              sélectionnée.
              <a
                href="javascript:void(0)"
                class="adjust-link"
                (click)="updateTimeSlotToMatchDate()"
              >
                Mettre à jour le créneau
              </a>
            </div>
          </div>
        </div>

        <div class="grid">
          <div class="col-12 md:col-6">
            <label for="startTimeSlot" class="font-bold mb-2"
              >Heure de début*</label
            >
            <p-datepicker
              id="startTimeSlot"
              formControlName="startTimeSlot"
              [timeOnly]="true"
              styleClass="w-full"
              hourFormat="24"
              [showIcon]="true"
              [showSeconds]="true"
              appendTo="body"
              [touchUI]="false"
            ></p-datepicker>
            <small
              *ngIf="
                shiftForm.get('startTimeSlot')?.invalid &&
                shiftForm.get('startTimeSlot')?.touched
              "
              class="p-error mt-1"
            >
              Veuillez sélectionner une heure de début.
            </small>
          </div>

          <div class="col-12 md:col-6">
            <label for="endTimeSlot" class="font-bold mb-2"
              >Heure de fin*</label
            >
            <p-datepicker
              id="endTimeSlot"
              formControlName="endTimeSlot"
              [timeOnly]="true"
              styleClass="w-full"
              hourFormat="24"
              [showIcon]="true"
              [showSeconds]="true"
              appendTo="body"
              [touchUI]="false"
            ></p-datepicker>
            <small
              *ngIf="
                shiftForm.get('endTimeSlot')?.invalid &&
                shiftForm.get('endTimeSlot')?.touched
              "
              class="p-error mt-1"
            >
              Veuillez sélectionner une heure de fin.
            </small>
          </div>
        </div>
      </div>

      <!-- Origine du décalage -->
      <div class="flex flex-col mb-2">
        <label for="shiftOriginId" class="font-bold mb-2"
          >Origine du décalage*</label
        >
        <p-select
          id="shiftOriginId"
          formControlName="shiftOriginId"
          [options]="shiftOrigins"
          optionLabel="name"
          optionValue="id"
          placeholder="Sélectionnez une origine"
          styleClass="w-full"
          appendTo="body"
          [scrollHeight]="'200px'"
        >
          <ng-template pTemplate="selectedItem" let-origin>
            <div class="flex align-items-center gap-2" *ngIf="origin">
              <span
                class="color-dot"
                [style.background-color]="origin.color"
              ></span>
              <div>{{ origin.name }}</div>
            </div>
          </ng-template>
          <ng-template pTemplate="item" let-origin>
            <div class="flex align-items-center gap-2">
              <span
                class="color-dot"
                [style.background-color]="origin.color"
              ></span>
              <div>{{ origin.name }}</div>
            </div>
          </ng-template>
        </p-select>
      </div>

      <!-- Motif du décalage -->
      <div class="flex flex-col">
        <label for="reason" class="font-bold mb-2">Motif du décalage</label>
        <textarea
          id="reason"
          pTextarea
          formControlName="reason"
          [rows]="3"
          placeholder="Facultatif: Vous pouvez saisir un motif de décalage"
          class="w-full p-2"
        ></textarea>
      </div>
    </form>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <button
        pButton
        label="Annuler"
        icon="pi pi-times"
        class="p-button-text"
        [disabled]="submitting"
        (click)="hide()"
      ></button>
      <button
        pButton
        label="Décaler"
        icon="pi pi-check"
        [loading]="submitting"
        [disabled]="shiftForm.invalid || loadingShiftOrigins || submitting"
        (click)="submit()"
      ></button>
    </div>
  </ng-template>
</p-dialog>
